/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import StorageService from '@/api/Storage';
import store from '../../store/index';

export default class BaseAPIClient {
  constructor($http) {
    this.baseUrl = Vue.prototype.$globalEnv.baseUrl;
    this.http = $http;
    this.$store = store;
  }

  async _refreshToken(whenDone) {
    const refreshToken = StorageService.getItem('refreshToken') || '';

    if (!refreshToken) {
      return whenDone(false);
    }

    return this.request('post', 'auth/token/refresh/', {
      refresh: refreshToken,
    }, true).then((results) => {
      if (results && results.access) {
        this.$store.commit('setTokens', results);
        return whenDone(true);
      }
      return whenDone(false);
    }).catch(() => whenDone(false));
  }

  async refreshToken() {
    return this._refreshToken(() => {});
  }

  async _get(url, params) {
    return this.requestWithParams('get', url, params);
  }

  async _getUrl(url) {
    const accessToken = StorageService.getItem('accessToken') || '';

    const headers = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return this.http.get(url, {
      headers,
    }).then(this._handleResponse);
  }

  async _delete(url, params) {
    return this.requestWithParams('delete', url, params);
  }

  async _post(url, data) {
    return this.request('post', url, data);
  }

  async _postMedia(url, formData) {
    return this.request('post', url, formData);
  }

  async _basicAuthPost(url, email, password, params) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${window.btoa(`${email}:${password}`)}`,
    };

    return this.http.post(`${this.baseUrl}/${url}`, params || {}, {
      headers,
    }).then(this._handleResponse);
  }

  async _put(url, data) {
    return this.request('put', url, data);
  }

  async _patch(url, data) {
    return this.request('patch', url, data);
  }


  _handleResponse(results) {
    if (results && results.ok) {
      return results.body;
    }
    return {};
  }

  // create generic request
  async fetchWithParams(action, url, params, fromRefreshWorkflow) {
    const accessToken = StorageService.getItem('accessToken') || '';

    const headers = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }
    const queryParams = params
      ? Object.keys(params)
        .filter(key => params[key])
        .map(key => `${key}=${params[key]}`)
        .join('&') : '';
    return fetch(`${this.baseUrl}/${url}?${queryParams}`, {
      headers,
      params: params || {},
      method: action,
    }).catch((ex) => {
      if (!fromRefreshWorkflow && ex && ex.status === 401) {
        // refresh token, try again
        return this._refreshToken((refreshed) => {
          if (refreshed) {
            // try again
            return this.fetchWithParams(action, url, params, true);
          }
          // error out
          throw ex;
        });
      }
      throw ex;
    });
  }

  // create generic request
  async requestWithParams(action, url, params, fromRefreshWorkflow) {
    const accessToken = StorageService.getItem('accessToken') || '';

    const headers = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return this.http[action](`${this.baseUrl}/${url}`, {
      headers,
      params: params || {},
    }).then(this._handleResponse).catch((ex) => {
      if (!fromRefreshWorkflow && ex && ex.status === 401) {
        // refresh token, try again
        return this._refreshToken((refreshed) => {
          if (refreshed) {
            // try again
            return this.requestWithParams(action, url, params, true);
          }
          // error out
          throw ex;
        });
      }
      throw ex;
    });
  }

  async request(action, url, data, fromRefreshWorkflow) {
    const accessToken = StorageService.getItem('accessToken') || '';

    const headers = {
      'Content-Type': 'application/json',
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return this.http[action](`${this.baseUrl}/${url}`, data, {
      headers,
    }).then(this._handleResponse).catch((ex) => {
      if (!fromRefreshWorkflow && ex && ex.status === 401) {
        // refresh token, try again
        return this._refreshToken((refreshed) => {
          if (refreshed) {
            // try again
            return this.request(action, url, data, true);
          }
          // error out
          throw ex;
        });
      }
      throw ex;
    });
  }
}
